import { ApiClient } from './client.js'
import { PLAN_CHANGE_REQUESTS } from './resources.js'

const client = new ApiClient()

export default {
  create (data) {
    return client.post(`${PLAN_CHANGE_REQUESTS}`, data)
  }
}
